import i18n from '../i18n'

export const API_ERRORS = [
  {
    errorMessage: 'ERROR.INVALID.ACCESS_DENIED',
    translation: i18n.t('errors.invalid.access_denied'),
  }, // invalid magic token from magic link
  { errorMessage: 'ERROR.EXPIRED.OFFERLIMIT', translation: i18n.t('errors.no_offers_left') },
  { errorMessage: 'ERROR.INCORRECT.CODE', translation: i18n.t('errors.incorrect.email') },
  { errorMessage: 'ERROR.INCORRECT.EMAIL', translation: i18n.t('errors.incorrect.email') },
  { errorMessage: 'ERROR.LOW.LOYALTYPOINTS', translation: i18n.t('errors.low.loyalty_points') },
  { errorMessage: 'ERROR.NOT.FOUND', translation: i18n.t('errors.not.found') },
  { errorMessage: 'ERROR.PASSWORDLESS.AUTH', translation: i18n.t('errors.passwordless.auth') }, //error with validating magic token
  { errorMessage: 'Missing authentication', translation: i18n.t('errors.missing_auth') },
  { errorMessage: 'Token expired', translation: i18n.t('errors.token.expired') },
  { errorMessage: 'Token invalid', translation: i18n.t('errors.token.invalid') },
]
export const getApiError = (errorMessage: string) => {
  const api_error = API_ERRORS.find((el) => el.errorMessage === errorMessage)
  return api_error
}
